module.exports = {
    RESET_SUBSCRIPTION: 'RESET_SUBSCRIPTION',
    RECEIVE_ALL_SUBSCRIPTIONS: 'RECEIVE_ALL_SUBSCRIPTIONS',
    RECEIVE_SUBSCRIPTION: 'RECEIVE_SUBSCRIPTION',
    RECEIVE_SUBSCRIPTIONS_LAST_SITUATIONS: 'RECEIVE_SUBSCRIPTIONS_LAST_SITUATIONS',
    RECEIVE_ALL_SUBSCRIPTION_SITUATIONS: 'RECEIVE_ALL_SUBSCRIPTION_SITUATIONS',
    RECEIVE_SIM_SUBSCRIPTIONS_LAST_SITUATIONS: 'RECEIVE_SIM_SUBSCRIPTIONS_LAST_SITUATIONS',
    RECEIVE_SUBSCRIPTION_TYPES: 'RECEIVE_SUBSCRIPTION_TYPES',
    RECEIVE_SUBSCRIPTION_SIM_LINK: 'RECEIVE_SUBSCRIPTION_SIM_LINK',
}